export const HOME_ROUTE = "/user";
export const FORGOT_ROUTE = "/forgot-password";

export const CART_ROUTE = "/cart";
export const WISHLIST_ROUTE = "/wishlist";
export const CHECKOUT_ROUTE = "/checkout";
export const LOGIN_ROUTE = "/auth/login";
export const ABOUT_ROUTE = "/about";
export const CONTACT_ROUTE = "/contact";
export const REGISTER_ROUTE = "/auth/signup";
export const SHOP_ROUTE = "/shop";
export const BUYING_FAQ_ROUTE = "/faqs";
export const REFUND_POLICY_ROUTE = "/return-policy";
export const WARRANTY_POLICY_ROUTE = "/warranty-policy";


export const PRIVACY_POLICY_ROUTE = "/privacy-policy";
export const TERMS_CONDITION_ROUTE = "/terms-condition";
export const RETURN_POLICY_ROUTE = "/return-policy";
export const SHIPPING_POLICY_ROUTE = "/shipping-policy";
export const DASHBOARD_ROUTE = "/user/dashboard";
export const SURVEY_RESPONSE_ROUTE = "/user/survey-response";
export const PROFILE_ROUTE = "/user/profile";
export const COUPON_ROUTE = "/user/coupon";
export const OREDR_ROUTE = "/user/orders";
export const DELETE_ACCOUNT_ROUTE = "/delete-account";

export const USER_DASHBOARD_ROUTE = "/my-account";
export const USER_PROFILE_ROUTE = "/profile";
export const USER_OREDR_ROUTE = "/orders";


export const PRODUCTS_ROUTE = "/user/products";
export const LEDGER_ROUTE = "/user/my-balance";
export const COLLECTION_ROUTE = "/user/colleaction-history";



export function PRODUCT_ROUTE(id, slug) {
  return `/product/${id}/${slug}`;
}

export function VENDOR_PRODUCT_ROUTE(id) {
  return `/products/${id}`;
}
export function VENDOR_MANAGER_ROUTE(id) {
  return `/user/vednor-manager/${id}`;
}
export function ORDER_DEATILS_PRODUCT_ROUTE(id) {
  return `/user/order-details/${id}`;
}
